import { Table } from "antd";
import styles from "./styles.module.scss";
import { useState } from "react";
import { ComputersTable } from "./computers-table";

export const GeographicalUserInsights = () => {
  const [openDetailModal, setOpenDetailModal] = useState(false);
  return (
    <div>
      <ComputersTable setOpenDetailModal={setOpenDetailModal} />
    </div>
  );
};
